import * as React from "react";
import app from "../../core/application";
import * as Constants from "../../core/constants";
import { sendRequest } from "../../helpers/ajax";
import IClientSearchRequest from "../../types/IClientSearchRequest";
import IClientSearchResult from "../../types/IClientSearchResult";
import IListResults from "../../types/IListResults";
import IResponse from "../../types/IResponse";
import ClientList from "./ClientList";

interface IClientListState {
    page: number;
    records: IClientSearchResult[];
    moreRecordsExist: boolean;
    loading: boolean;
}

class ClientListContainer extends React.Component<{}, IClientListState> {

    constructor(props: {}) {
        super(props);

        this.state = {
            page: 1,
            records: [],
            moreRecordsExist: false,
            loading: false
        };

        this.search = this.search.bind(this);
    }

    public async componentDidMount() {
        await this.search({ 
            page: this.state.page, 
            showActive: true 
        }
        , true);
    }

    public render() {
        return (
            <ClientList
                loading={this.state.loading}
                records={this.state.records}
                moreRecordsExist={this.state.moreRecordsExist}
                canLoginAsClient={app().userHasPermission(Constants.PERMISSION_ADMINACCESSTOALLCLIENTS)}
                search={this.search}
            />
        );
    }

    private async search(criteria: IClientSearchRequest, resetPage: boolean) {
        this.setState({ loading: true });

        criteria.page = resetPage ? 1 : this.state.page;

        const result = await sendRequest<IResponse<IListResults<IClientSearchResult>>>("/api/clients/search", "POST", criteria);
        if (result && result.success) {
            this.setState((state: IClientListState): IClientListState => {

                if (resetPage) {
                    state.records = [];
                    state.page = 1;
                }

                state.page++;
                state.records.push(...result.payload.records);
                state.moreRecordsExist = result.payload.moreRecordsExist;

                return state;
            });
        }

        this.setState({ loading: false });
    }
}

export default ClientListContainer;



// WEBPACK FOOTER //
// ./src/components/ClientList/ClientListContainer.tsx